import React, { useContext } from "react";
import { Grid, GridSize, IconButton, Tooltip, Typography } from "@material-ui/core";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DiscFullIcon from "@mui/icons-material/DiscFull";
import LastPageIcon from "@mui/icons-material/LastPage";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import { UserAlarmsDto, UserNotificationDto } from "../../../../../api/APIClient";
import PanelProjectContext from "../../../../PanelProjectProvider";
import { BDTRoutes } from "../../../../../helpers/applicationConstants";
import "./styles.css";

enum NotificationType {
    NOTIFICATION = "notification",
    ALARM = "alarm",
}

interface AlarmPopoverProps {
    alerts: UserNotificationDto[] | UserAlarmsDto[];
    handlePanelItemClick: (route: string, asset: string, type?: string) => void;
    handleReadNotifications: (notId: string, projectid: string) => void;
    notificationType: "notification" | "alarm";
}

const AlertPopover = ({
    alerts,
    handlePanelItemClick,
    handleReadNotifications,
    notificationType,
}: AlarmPopoverProps) => {
    const { t } = useTranslation("main");
    const { project } = useContext(PanelProjectContext);

    const handleOnClick = (additionalParams, titleParams, alarmType) => {
        if (notificationType === NotificationType.ALARM) {
            handlePanelItemClick(
                BDTRoutes.Project.Viewer.Viewer.Builder(project.id),
                additionalParams,
                alarmType
            );
        } else if (notificationType === NotificationType.NOTIFICATION) {
            handlePanelItemClick(
                BDTRoutes.Project.Viewer.Viewer.Builder(project.id),
                titleParams,
                undefined
            );
        }
    };

    const showRedirectButton = (alert: UserNotificationDto | UserAlarmsDto) => {
        if (notificationType === NotificationType.ALARM) {
            return true;
        }

        if (notificationType === NotificationType.NOTIFICATION) {
            if (alert.titleParams) {
                return true;
            }
            return false;
        }

        return false;
    };

    const resizeGridItems = (alert) => {
        return {
            gridIconSize: 1 as GridSize,
            gridTitleSize: (showRedirectButton(alert) ? 2 : 3) as GridSize,
            gridDescriptionSize: (showRedirectButton(alert) ? 4 : 5) as GridSize,
            gridDateSize: 3 as GridSize,
            gridRedirectSize: (showRedirectButton(alert) ? 2 : 0) as GridSize,
        };
    };

    return (
        <>
            {alerts
                .sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime())
                .map((alert) => {
                    const additionalParams = (alert as UserAlarmsDto).aditionalParams;
                    let IconComponent;
                    if (notificationType === NotificationType.ALARM) {
                        IconComponent = alert.read ? ErrorOutlineIcon : DiscFullIcon;
                    } else if (notificationType === NotificationType.NOTIFICATION) {
                        IconComponent = alert.read ? MarkEmailReadIcon : MarkEmailUnreadIcon;
                    }
                    const {
                        gridIconSize,
                        gridTitleSize,
                        gridDescriptionSize,
                        gridDateSize,
                        gridRedirectSize,
                    } = resizeGridItems(alert);

                    return (
                        <Grid container key={alert.ids} className="grid-root" spacing={2}>
                            <Grid item xs={gridIconSize}>
                                <Tooltip title={t("topbar.markAsRead").toString()} arrow>
                                    <IconButton
                                        onClick={() => {
                                            handleReadNotifications(alert.ids, project.id);
                                        }}
                                    >
                                        <IconComponent />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={gridTitleSize} className="display-flex">
                                <Typography className="align-self">{alert.title}</Typography>
                            </Grid>
                            <Grid item xs={gridDescriptionSize} className="display-flex">
                                <Tooltip
                                    title={
                                        <Typography variant="body1">{alert.description}</Typography>
                                    }
                                >
                                    <Typography
                                        variant="body2"
                                        className={classnames("align-self", "alarm-description")}
                                    >
                                        {alert.description}
                                    </Typography>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={gridDateSize} className="display-flex">
                                <Typography
                                    variant="body2"
                                    className={classnames("date", "align-self")}
                                >
                                    {alert.created.toString().split("T")[0]}{" "}
                                    {alert.created.toString().split("T")[1].split(".")[0]}
                                </Typography>
                            </Grid>
                            {showRedirectButton(alert) && (
                                <Grid item xs={gridRedirectSize} className="display-flex">
                                    <Tooltip title={`${t("topbar.accessToPanel")}`}>
                                        <IconButton
                                            onClick={() =>
                                                handleOnClick(
                                                    additionalParams,
                                                    alert.titleParams,
                                                    alert.alarmType
                                                )
                                            }
                                        >
                                            <LastPageIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            )}
                            {/* <Grid item xs={2} className="display-flex">
                                <Tooltip title={`${t("topbar.accessToPanel")}`}>
                                    <IconButton
                                        onClick={() =>
                                            handleOnClick(additionalParams, alert.titleParams)
                                        }
                                    >
                                        <LastPageIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid> */}
                        </Grid>
                    );
                })}
        </>
    );
};

export default AlertPopover;
